import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import NavigationBar from '@/components/NavigationBar.vue';

  import '@/utils/logger.ts';

  import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/vue'

  // 1. Get projectId at https://cloud.walletconnect.com
  const projectId = '0e27ea1ee16736b882098e295adbb87c'

  // 2. Set chains
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const mainnet = {
    chainId: 1,
    name: 'Ethereum',
    currency: 'ETH',
    explorerUrl: 'https://etherscan.io',
    rpcUrl: 'https://cloudflare-eth.com'
  }

  const moonbeam = {
  chainId: 1284, // Or 1287 for Moonbase Alpha
  name: 'Moonbeam',
  currency: 'GLMR',
  explorerUrl: 'https://moonscan.io', // Moonbeam block explorer
  rpcUrl: 'https://rpc.api.moonbeam.network' // Or 'https://rpc.testnet.moonbeam.network' for the testnet
  }

  const polygon = {
    chainId: 137,
    name: 'Polygon',
    currency: 'MATIC',
    explorerUrl: 'https://polygonscan.com',
    rpcUrl: 'https://polygon-rpc.com'
  }

  // 3. Create your application's metadata object
  const metadata = {
    name: 'Beat Pressure',
    description: 'My Website description',
    url: 'https://beatpressure.io', // url must match your domain & subdomain
    // icons: ['https://avatars.mywebsite.com/']
  }

  // 4. Create Ethers config
  const ethersConfig = defaultConfig({
    /*Required*/
    metadata,

    /*Optional*/
    enableEIP6963: true, // true by default
    enableInjected: true, // true by default
    enableCoinbase: true, // true by default
    // rpcUrl: '...', // used for the Coinbase SDK
    // defaultChainId: 1, // used for the Coinbase SDK
  })

  // 5. Create a Web3Modal instance
  createWeb3Modal({
    ethersConfig,
    chains: [mainnet, moonbeam, polygon],
    projectId,
  })



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavigationBar),
    _createVNode(_component_router_view)
  ], 64))
}
}

})